;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ["url", "token", "origin"],
    mounted: function mounted() {
        this.submitForm();
        window.addEventListener("message", this.handleMessage, false);
    },

    methods: {
        submitForm: function submitForm() {
            this.$refs.collectionForm.submit();
        },
        handleMessage: function handleMessage(event) {
            if (event.origin === this.origin) {
                this.$emit("enrollmentChecked", event.data);
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("message", this.handleMessage, false);
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"collectionIframe",staticStyle:{"display":"none"},attrs:{"name":"collectionIframe","height":"10","width":"10"}}),_vm._v(" "),_c('form',{ref:"collectionForm",attrs:{"method":"POST","target":"collectionIframe","action":_vm.url}},[_c('input',{attrs:{"type":"hidden","name":"JWT"},domProps:{"value":_vm.token}})])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f235c3c", __vue__options__)
  } else {
    hotAPI.reload("data-v-5f235c3c", __vue__options__)
  }
})()}